// Convert date format to YYYY-MM-DD hh:mm:ss
// https://bobbyhadz.com/blog/javascript-format-date-yyyy-mm-dd-hh-mm-ss

function padTo2Digits (num: number): string {
  return num.toString().padStart(2, '0')
}

export function formatDate (date: Date): string {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate())
    ].join('-')
  )
}

export function formatDateTime (date: Date): string {
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate())
    ].join('-') +
    ' ' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds())
    ].join(':')
  )
}
